<template>
  <v-card>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-container>
        <v-layout>
          <v-flex xs12 md4>
            <v-autocomplete
              :items="power_plants"
              item-text="name"
              prepend-icon="flash_on"
              label="Planta"
              v-model="power_plant"
              return-object
              clearable
              :rules="powerPlantRules"
            ></v-autocomplete>
          </v-flex>

          <v-flex xs12 md2>
            <v-text-field
              v-model="competence"
              :rules="competenceRules"
              label="Competencia"
              prepend-icon="event"
              class="purple-input"
              :value="current_date"
              @keyup.enter="validate"
              mask="##/####"
            />
          </v-flex>

          <v-flex xs12 md4>
            <v-select
              v-model="status"
              :items="statusList"
              label="Status"
              multiple
              chips
              hint="(opcional)"
              persistent-hint
              item-text="text"
              item-value="value"
            >
            </v-select>
          </v-flex>

          <v-flex xs12 md3 d-flex>
            <v-flex xs6 md6 class="text-lg-right">
              <v-btn
                color="primary"
                @click="validate()"
                :loading="loading"
                small
                outline
                slot="start"
              >
                <v-icon>search</v-icon>Buscar
              </v-btn>
            </v-flex>
            <v-spacer />
            <v-flex xs6 md6 v-if="isAdmin || isFinancial">
              <v-btn
                color="success"
                @click="invoiceForm()"
                :disabled="loading"
                small
                outline
                slot="end"
              >
                <v-icon class="pr-1">receipt_long</v-icon>Adicionar/Editar
              </v-btn>
            </v-flex>
          </v-flex>
        </v-layout>
        <!-- <v-flex xs12 md12>
          <p>* Para uma busca mais rápida selecione apenas um filtro e uma opção no caso do status.</p>
        </v-flex> -->
      </v-container>
    </v-form>
    <InvoiceCompetenceForm
      :power_plants="power_plants"
      @showSnack="showSnack"
    ></InvoiceCompetenceForm>
    <v-snackbar
      :color="color"
      :bottom="bottom"
      :top="top"
      :left="left"
      :right="right"
      v-model="snackbar"
      dark
    >
      <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
      <div>{{ snackMessage }}</div>
      <v-icon size="16" @click="snackbar = false"> mdi-close-circle </v-icon>
    </v-snackbar>
  </v-card>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { statusList } from "../../utils/billing_status.json";
import { EventBus } from "../../utils/event-bus";
import InvoiceCompetenceForm from "../faturar/InvoiceCompetenceForm";

export default {
  // props: ['powerplants'],
  components: {
    InvoiceCompetenceForm,
  },
  data: () => ({
    // competence: '',
    // power_plant: '',
    power_plants: [],
    valid: false,
    // loading: false,
    invoices: [],
    statusList: statusList,
    current_date: new Date(),
    powerPlantRules: [
      // v => !!v || 'Por favor, selecione a planta que deseja ver as faturas.',
    ],
    competenceRules: [
      // v => !!v || 'Por favor, preencher a competência da fatura.',
      (v) =>
        !(v.substr(2, 4) < 2019) ||
        !v ||
        "Por favor, o ano deve ser valido. " + v.substr(2, 4),
      (v) =>
        !(v.substr(0, 2) > 12) ||
        !v ||
        "Por favor, o mes deve ser valido. " + v.substr(0, 2),
    ],
    color: null,
    colors: ["purple", "info", "success", "warning", "error"],
    top: true,
    bottom: false,
    left: false,
    right: false,
    snackMessage: "",
    snackbar: false,
  }),
  async created() {
    // console.log('created power_plants: ', this.power_plants)
    if (!this.powerplants || this.power_plants.length <= 0) {
      const pp = await this.getPowerPlants();
      // console.log('pp: ', pp)
      this.power_plants = this.filterPowerPlants(pp);
    }
    if (this.filters && this.filters.power_plant) {
      this.power_plant = this.filters.power_plant;
    }
    if (this.filters && this.filters.competence) {
      this.competence = this.filters.competence;
    }
  },
  computed: {
    ...mapState(["powerplants", "user"]),
    ...mapState("billing", ["billingFilters", "loading"]),
    status: {
      get() {
        // console.log('status: ', this.$store.state.billing.billingFilters.status)
        return this.$store.state.billing.billingFilters.status;
      },
      set(value) {
        this.$store.commit("billing/setBillingFilterStatus", value);
      },
    },

    power_plant: {
      get() {
        // console.log('power_plant: ', this.$store.state.billing.billingFilters.power_plant_id)
        return this.$store.state.billing.billingFilters.power_plant_id;
      },
      set(value) {
        // console.log('power_plant value:', value)
        this.$store.commit("billing/setBillingFilterPowerPlant", value);
      },
    },
    competence: {
      get() {
        // console.log('competence: ', this.billingFilters.competence)
        return this.billingFilters.competence;
      },
      set(value) {
        // console.log('competence value:', value)
        this.$store.commit("billing/setBillingFilterCompetence", value);
      },
    },
    likesAllStatus() {
      return this.status.length === this.statusList.length;
    },
    likesSomeStatus() {
      return this.status.length > 0 && !this.likesAllStatus;
    },
    icon() {
      if (this.likesAllStatus) return "mdi-close-box";
      if (this.likesSomeStatus) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    isAdmin() {
      let currentUserGroups = this.user.group.toString();
      if (currentUserGroups.indexOf("admin") >= 0) {
        return true;
      }
      return false;
    },
    isFinancial() {
      let currentUserGroups = this.user.group.toString();
      if (currentUserGroups.indexOf("financial") >= 0) {
        return true;
      }
      return false;
    },
  },
  watch: {
    power_plants() {
      // console.log('watch power_plants: ', this.power_plants)
      if (!this.power_plants && this.powerplants) {
        this.power_plants = this.filterPowerPlants(this.powerplants);
      }
    },
  },
  methods: {
    toggle() {
      this.$nextTick(() => {
        if (this.likesAllStatus) {
          this.status = [];
        } else {
          this.status = this.statusList.slice().map((item) => item.value);
        }
      });
    },
    async validate() {
      if (this.$refs.form.validate()) {
        if (!this.power_plant && !this.competence && !this.status?.length > 0) {
          this.showSnack("Aplique pelo menos um filtro.", "red");
          this.valid = false;
          return;
        }
        this.valid = true;
        // console.log('this.power_plant: ', this.power_plant.id)
        // console.log('this.competence: ', this.competence)
        // console.log('this.status: ', this.status)
        let params = {
          power_plant_id: this.power_plant ? this.power_plant.id : "",
          competence: this.competence,
          status: this.status,
        };

        if (params.status.length > 10) {
          this.showSnack(
            "Não é possível considerar mais de 10 status diferentes no filtro.",
            "red",
          );
          return;
        }

        await this.getBillingByParams(params);
      }
    },
    filterPowerPlants(_powerplants) {
      var PowerPlantArray = [];
      if (_powerplants && this.user) {
        if (
          this.user.group &&
          (this.user.group.indexOf("admin") >= 0 ||
            this.user.group.indexOf("financial") >= 0)
        )
          return _powerplants;
        const user_pp = this.user.powerplants || this.user.power_plants;

        if (user_pp && user_pp.length > 0) {
          _powerplants.filter((power_plant) => {
            return user_pp.filter((power_plant2) => {
              if (power_plant2.power_plant_id === power_plant.id) {
                PowerPlantArray.push(power_plant);
              }
            });
          });
        }
      }
      return PowerPlantArray;
    },
    invoiceForm() {
      EventBus.$emit("showForm", true);
    },
    ...mapActions(["getPowerPlants"]),
    ...mapActions("billing", ["getBillingByParams"]),

    showSnack(message, color) {
      this.color = color;
      this.snackMessage = message;
      this.snackbar = true;
    },
  },
};
</script>
